// extracted by mini-css-extract-plugin
export default {"tierTable":"LateManagement_tierTable__FegZr"};